import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Agenda from './pages/Agenda';
import Panel from './pages/Panel';
import Inscricao from './pages/Inscricao';
import InscricaoImprensa from './pages/InscricaoImprensa';
import Imprensa from './pages/Imprensa';
import Events from './pages/Events';
import News from './pages/News';
import Local from './pages/Local';
import Login from './pages/Login';
import Salas from './pages/Salas';
import PageBr from './pages/PageBr';
import PageEn from './pages/PageEn';

export default function Routing() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/home" element={<Home />} />
                <Route path="/programacao" element={<Agenda />} />
                <Route path="/agenda" element={<Agenda />} />
                <Route path="/painelistas" element={<Panel />} />
                <Route path="/painelista/:url" element={<Panel />} />
                <Route path="/inscricao" element={<Inscricao />} />
                <Route path="/inscricao-imprensa" element={<InscricaoImprensa />} />
                <Route path="/imprensa" element={<Imprensa />} />
                <Route path="/noticias" element={<News />} />
                <Route path="/noticia/:url" element={<News />} />
                <Route path="/eventos" element={<Events />} />
                <Route path="/evento/:url" element={<Events />} />
                <Route path="/local" element={<Local />} />
                <Route path="/local-evento" element={<Local />} />
                <Route path="/login" element={<Login />} />
                <Route path="/assistir" element={<Salas />} />
                <Route path="/salas" element={<Salas />} />
                <Route path="/sala/:url" element={<Salas />} />
                <Route path="/pt" element={<PageBr />} />
                <Route path="/en" element={<PageEn />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </BrowserRouter>
    );
}
